import React from "react";
import PropTypes from "prop-types";
import "./SkipToContent.scss";

export default function SkipToContent({ contentId = "MainContent", skipText = "Skip to content" }) {
  return (
    <button
      className="SkipToContent is-visuallyHidden is-focusable"
      onClick={() => document.getElementById(contentId).focus()}
      type="button"
    >
      {skipText}
    </button>
  );
}

SkipToContent.propTypes = {
  /** Element id for focus when user clicks button. That element needs to have its tabindex attribute set to -1 if it is not normally focus-able (like a div). */
  contentId: PropTypes.string,
  /** Text to show in the skip button. */
  skipText: PropTypes.string,
};
